import type { BrokerDocumentType, S3File } from "@dune/types";
import { brokerDocumentTypeLabels } from "@dune/types";
import React from "react";
import UploadDocumentModal, {
	type DocumentTypeOption,
} from "../../../../../component/common/UploadDocumentModal";
import { useUploadBrokerDocument } from "../../../../../api/mutations/societies.mutations";
import { fileOnSocietyTypes } from "@dune/vars";

interface UploadDocumentModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	brokerId: number;
}

const BrokerUploadDocumentModal: React.FC<UploadDocumentModalProps> = ({
	open,
	onOpenChange,
	brokerId,
}) => {
	const uploadDocument = useUploadBrokerDocument();

	const documentTypeOptions: DocumentTypeOption[] = fileOnSocietyTypes
		.filter((value) => value !== "LOGO")
		.map((value) => ({
			value,
			label: brokerDocumentTypeLabels[value],
		}));

	const handleUpload = async (params: {
		file?: S3File;
		documentType: string;
	}) => {
		if (!params.file) {
			throw new Error("File is required");
		}

		await uploadDocument.mutateAsync({
			brokerId,
			name: params.file.name,
			key: params.file.key,
			bucket: params.file.bucket,
			mimeType: params.file.type,
			type: params.documentType as BrokerDocumentType,
		});
	};

	return (
		<UploadDocumentModal
			open={open}
			onOpenChange={onOpenChange}
			documentTypeOptions={documentTypeOptions}
			onUpload={handleUpload}
			isPending={uploadDocument.isPending}
			requiresFileRegistration={false}
		/>
	);
};

export default BrokerUploadDocumentModal;
